import { SearchIcon } from "@cmp-src/icons/icons";
import { useOrgFeatureFlag } from "@gettactic/hooks";

interface EmptyStateProps {
  isLoading?: boolean;
}

export function EmptyState({ isLoading = false }: EmptyStateProps) {
  const tessaFeatureFlag = useOrgFeatureFlag("tessa");
  if (isLoading) {
    return (
      <div className="flex items-center justify-center py-12">
        <div className="h-8 w-8 animate-spin rounded-full border-4 border-neutral-200 border-t-blue-500" />
      </div>
    );
  }

  const content = !tessaFeatureFlag
    ? {
        title: "Nothing found for your search",
        description: "Try adjusting your search query.",
        icon: <SearchIcon className="h-8 w-8 text-white" />
      }
    : {
        title: "Use Tessa",
        description: "Press Enter to ask Tessa",
        icon: (
          <svg
            className="h-8 w-8 text-white"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z"
            />
          </svg>
        )
      };

  return (
    <div className="flex flex-col items-center justify-center py-12">
      <div className="mb-4 flex h-16 w-16 items-center justify-center rounded-full bg-gradient-to-br from-purple-500 to-pink-500">
        {content.icon}
      </div>
      <h3 className="mb-2 font-semibold text-neutral-900 text-lg">
        {content.title}
      </h3>
      <p className="mb-4 text-center text-neutral-600 text-sm">
        {content.description}
      </p>
    </div>
  );
}
